import type { ImgHTMLAttributes, ReactNode } from "react";

/**
 * A picture with a REAL JPEG fallback (card-86 round 2, batch P — «مار پله»'s art): the `<img src>` is
 * ALWAYS the JPEG, and a WebP twin, when the art has one, only ADDS a `<source type="image/webp">` in
 * a `<picture>` — so a phone that cannot show WebP shows the JPEG, and one that can downloads only the
 * WebP. The `<img>` keeps every attribute it is given (class, alt, aria), and the `<picture>` is
 * `display: contents`, so the layout is the `<img>`'s own exactly as before. No `webp` → the bare
 * `<img>`, byte for byte the element the site drew without this component. Nothing else.
 */
export function ArtPicture({
  webp,
  ...img
}: ImgHTMLAttributes<HTMLImageElement> & { readonly webp?: string | undefined }): ReactNode {
  const el = <img {...img} />;
  if (!webp) return el;
  return (
    <picture style={{ display: "contents" }}>
      <source type="image/webp" srcSet={webp} />
      {el}
    </picture>
  );
}
